/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import { mutationEndpoints, queryEndpoints } from 'src/DistributionPackages/BestFit.Magicline/Resources/Private/App/Config/Api/ApiEndpointConfig';

/**
 * getMutationApiEndpoint service
 * @param apiEndpointKey
 * @returns {*}
 */
export const getMutationApiEndpoint = (apiEndpointKey) => {
  if (apiEndpointKey in mutationEndpoints) {
    return mutationEndpoints[apiEndpointKey];
  }

  throw Error(`Mutation endpoint "${apiEndpointKey}" in mapping not found!`);
};

export const getQueryApiEndpoint = (apiEndpointKey, urlReplaceParameter) => {
  if (apiEndpointKey in queryEndpoints) {
    return queryEndpoints[apiEndpointKey](urlReplaceParameter);
  }

  throw Error(`Query endpoint "${apiEndpointKey}" in mapping not found!`);
};
